import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import FirebaseService from './clients/firebase'
import FirestoreService from './clients/firestore'
import MessagingService from './clients/messaging'

FirebaseService.init();
FirestoreService.init();
MessagingService.init();

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
